import React from "react";
import { useParams, Link } from "react-router-dom";
import Layout from "../components/Layout";
import { CheckCircle2 } from "lucide-react";

export default function ReservationConfirmation() {
  const { id } = useParams();
  return (
    <Layout>
      <div className="max-w-2xl mx-auto px-6 py-20 text-center" data-testid="reservation-confirmation">
        <CheckCircle2 size={56} style={{ color: "var(--ab-primary)" }} className="mx-auto mb-6" />
        <div className="label-eyebrow mb-2" style={{ color: "var(--ab-primary)" }}>Reservation Sent</div>
        <h1 className="font-display text-4xl sm:text-5xl font-black mb-4">You're on the list.</h1>
        <p className="text-sm mb-3" style={{ color: "var(--ab-text-muted)" }}>
          We've received your purchase request. Please wait for further instructions — we'll email you back to confirm what's available and set a pickup window.
        </p>
        <p className="text-xs mb-8" style={{ color: "var(--ab-text-dim)" }} data-testid="reservation-id">Reference: {id?.slice(0, 8)}</p>
        <div className="flex gap-3 justify-center">
          <Link to="/inventory-lookup" className="btn-secondary" data-testid="reservation-back-shop">Keep Browsing</Link>
          <Link to="/" className="btn-primary" data-testid="reservation-back-home">Home</Link>
        </div>
      </div>
    </Layout>
  );
}
